// utils/normalizeLinks.js

export const normalizeInstagramLink = (link) => {
  if (!link?.trim()) return null;
  
  const newLink = (link.indexOf("https") < 0 && link?.indexOf("www") < 0) ? `https://www.instagram.com/${link}` : link;

//-------- end: not going with this approach now ------------.
//   const trimmed = link.trim();

//   // Already a full valid URL
//   if (trimmed.startsWith("https://www.instagram.com/") ||
//       trimmed.startsWith("https://instagram.com/")) {
//     return trimmed;
//   }

//   // Strip any accidental http:// or www. prefixes before username
//   const stripped = trimmed
//     .replace(/^https?:\/\//i, "")
//     .replace(/^www\.instagram\.com\//i, "")
//     .replace(/^instagram\.com\//i, "");

//  return `https://www.instagram.com/${stripped}`;
//-------- end: not going with this approach now ------------.

  return newLink;
};